// material-ui
import { Theme } from '@mui/material/styles';
import React from 'react';
// assets
import RightOutlined from '@ant-design/icons/RightOutlined';

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function AccordionSummary(theme: Theme) {
  const { palette, spacing } = theme;

  const expandIconStyle = {
    fontSize: '0.75rem',
  };

  return {
    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: <RightOutlined style={expandIconStyle} />,
      },
      styleOverrides: {
        root: {
          backgroundColor: palette.secondary.lighter,
          flexDirection: 'row-reverse',
          minHeight: 46,
        },
        expandIconWrapper: {
          '&.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
        },
        content: {
          marginTop: spacing(1.25),
          marginBottom: spacing(1.25),
          marginLeft: spacing(1),
          '&.Mui-expanded': {
            marginLeft: spacing(1),
          },
        },
      },
    },
  };
}
